<template>
  <modal id="removeAllProductsModal">
    <template slot="header">
      <div class="modal-header-content">
        <div class="modal-header-title">
          <h2>Remove All Products</h2>
        </div>
        <button
          type="button"
          class="modal-header-close"
          data-dismiss="modal"
          aria-label="Close"
        >
          ×
        </button>
      </div>
    </template>

    <form enctype="multipart/form-data">
      <div class="modal-form">
        <p>Clicking "Yes" will remove all of the products from your cart. Are you sure?</p>
      </div>
    </form>

    <template slot="footer">
      <div class="modal-footer-actions">
        <button
          type="button"
          class="modal-footer-cancel"
          data-dismiss="modal"
          aria-label="Close"
        >
          Cancel
        </button>
        <button
          @click="removeAllProducts()"
          class="modal-footer-save"
        >
          Yes
        </button>
      </div>
    </template>
  </modal>
</template>

<script>
  export default {
    methods: {
      async removeAllProducts() {
        await axios
          .post(`/api/proxify/domains/${this.$root.domain}/shop/cart/empty`)
          .then((res) => {
            // force a page reload
            window.location.reload()
          })
          .catch((error) => console.error('Remove all failed.'))
      },
    },
  }
</script>
